import { Injectable } from '@angular/core';
import { LoginService, LoginServiceI } from '@shared/services/login/login.service';
import { getOriginFromRoute } from '@dta/shared/utils/common-utils';

@Injectable()
export class LoginServiceWeb extends LoginService implements LoginServiceI {
  get clientParameter(): string {
    const origin = getOriginFromRoute();
    let param = 'from=web-app-' + origin;
    if (origin === 'local-host') {
      param += '&localUrl=' + encodeURIComponent(window.location.origin);
    }
    return param;
  }

  googleLogin(email: string, fullScope?: boolean): void {
    const origin = getOriginFromRoute();
    const redirectUrl = origin === 'local-host' ? window.location.origin : undefined;
    this._oAuthService.openExternalOAuth(email, 'google', { fullScope, sameWindow: true, redirectUrl });
  }

  microsoftLogin(email: string, fullScope?: boolean): void {
    const origin = getOriginFromRoute();
    const redirectUrl = origin === 'local-host' ? window.location.origin : undefined;
    this._oAuthService.openExternalOAuth(email, 'microsoft', { fullScope, sameWindow: true, redirectUrl });
  }
}
